import { render, staticRenderFns } from "./ClassNotes.vue?vue&type=template&id=bbeba208"
import script from "./ClassNotes.vue?vue&type=script&lang=js"
export * from "./ClassNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports